// @flow
import * as React from 'react';
import { FormGroup, Col, FormControl, ControlLabel } from 'react-bootstrap';
import type { Props } from './Props';

const TextInput = ({ title = 'new field', placeholder = '', defaultValue = '', disabled = false, type = 'text', onChange = () => {} }: Props): React.Element<any> => (
  <FormGroup controlId="formHorizontalEmail">
    <Col componentClass={ControlLabel} sm={3}>
      {title}
    </Col>
    <Col sm={9}>
      <FormControl
        type={type}
        placeholder={placeholder}
        defaultValue={defaultValue}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    </Col>
  </FormGroup>
);

export default TextInput;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/BrandedPage/components/TextInput/TextInput.js